import { createFileRoute } from "@tanstack/react-router"
import { procedureStepSettingsDetailViewStaticData } from "src/views/ProcedureStepSettingsDetailView/constants"
import { ProcedureStepSettingsDetailView } from "src/views/ProcedureStepSettingsDetailView/ProcedureStepSettingsDetailView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/",
)({
	component: ProcedureStepSettingsDetailView,
	staticData: procedureStepSettingsDetailViewStaticData,
})
